import { useQuery } from "@tanstack/react-query";

import { apiClient } from "../lib/apiClient";
import { ApiRequestError } from "../lib/errors";
import { queryKeys } from "../lib/queryKeys";

export function useScenarioBreadcrumbName(
  scenarioId: string | undefined,
): string | undefined {
  const scenario = useQuery({
    enabled: scenarioId !== undefined,
    queryKey: queryKeys.scenarios.detail(scenarioId ?? "pending"),
    queryFn: async () => {
      if (!scenarioId) {
        throw new Error("Scenario id is required.");
      }
      const { data, error } = await apiClient.GET("/v1/scenarios/{id}", {
        params: { path: { id: scenarioId } },
      });
      if (error) throw new ApiRequestError(error);
      return data;
    },
  });
  return scenario.data?.display_name;
}
